<script>
  import {onMount, setContext} from "svelte";
  import {writable} from "svelte/store";
  import {to, API} from "@API";
  import otoFamilyWhite from "@assets/oto_family.png";
  import otoFamilyGray from "@assets/oto_family_gray.png";
  import otoClinicBlack from "@assets/FertilityClinic_Lockup_Black.png";
  import otoClinicLight from "@assets/FertilityClinic_Lockup_Light.png";
  import otoTacticalBlack from "@assets/Tactical_Lockup_black.png";
  import otoTacticalLight from "@assets/Tactical_Lockup_light.png";
  import otoGymBlack from "@assets/Athlete_Lockup_black.png";
  import otoGymLight from "@assets/Athlete_Lockup_light.png";
  import tinycolor from "tinycolor2";
  import Tailwind from "../TailwindStyles.svelte";
  import MediaQuery from "@components/MediaQuery.svelte";
  import Loader from "@components/Loader.svelte";
  import posthog from 'posthog-js';
  import ShopProgress from "./ShopProgress.svelte"
  import {forcesLocalPickup} from '@utils/fulfillment.js';

  console.log(__buildEnv__)

  if(__buildEnv__ != 'local'){
    window.posthog = posthog;
    posthog.init('phc_spDRH8UjZ9rYb1LQcgY8TUYAki6cEtvK6WoCBFZIb3V', { api_host: 'https://app.posthog.com' });
  }


  const Providers = API.service(':type/:guid/service_providers');

  const serviceProviderTypes = {
      Health: 'Doctor',
      Gym: 'Coach',
      'Tactical & First Responders': "Director"
  }

  export let org;
  export let product;
  export let location;

  let currentStep; // currentStep of the shop flow
  let stepComplete;

  let serviceProviders = writable([]);
  let loading = false;
  let providersScope = [];

  org = JSON.parse(org);
  product = JSON.parse(product);

  let productInfo, cssVarStyles;
  let showPriceDetails = false;

  API.host(org.api);

  const accentColor = tinycolor(org.branding_primary_color);
  const overColor = tinycolor(org.branding_primary_color);
  const overSecondaryColor = tinycolor(org.branding_secondary_color);
  const isDark = tinycolor(org.branding_primary_color).isDark();
  function getFamilyLogo() {
    if (org.is_fertility_org) {
      return isDark ? otoClinicLight : otoClinicBlack;
    }
    if (org.type.toLowerCase() === 'tactical & first responders') {
      return isDark ? otoTacticalLight : otoTacticalBlack;
    }
    if (org.type.toLowerCase() === 'gym') {
      return isDark ? otoGymLight : otoGymBlack;
    }
    return isDark ? otoFamilyWhite : otoFamilyGray;
  }
  let familyLogo = getFamilyLogo();

  let styles = {
    'primary-color': org.branding_primary_color,
    'secondary-color': org.branding_secondary_color,
    'accent-color': accentColor.isLight() ? accentColor.darken(20).toHexString() : accentColor.lighten(20).toHexString(),
    'over-primary-color': overColor.isLight() ? overColor.darken(100).toHexString() : overColor.lighten(100).toHexString(),
    'over-secondary-color': overSecondaryColor.isLight() ? overSecondaryColor.darken(100).toHexString() : overSecondaryColor.lighten(100).toHexString()
  };

  const urlParams = new URLSearchParams(window.location.search);
  const isGlobal = urlParams.get('global') === 'true';

  $: cssVarStyles = Object.entries(styles)
          .map(([key, value]) => `--${key}:${value}`)
          .join(';');


  // used to store information about the shop session
  let shopData = writable({
    location:false,
    price:null,
    pick_up_location: "Mail to me",
    isLocationSpecific: false
  });

  if(location){
    location = JSON.parse(location);
    $shopData.location = location.guid;
    $shopData.isLocationSpecific = true;
    $shopData.allowLocalPickup = location.allow_local_pickup;
    if (forcesLocalPickup(location, org)) {
      $shopData.pick_up_location = "Pick up at location";
    }
    providersScope = {type:'locations', guid:location.guid};
  } else {
    providersScope = {type:'organizations', guid:org.guid};
    location = null
  }

  $:largeScreen = window.innerHeight > 900 && window.innerWidth > 1100;

  if(!isGlobal){
    getServiceProviders(providersScope);  
  }

  if(org && window.posthog){
    posthog.register({
        'organization': org.nme,
        'product':product.nme
    })
  }
  if(window.posthog){
    posthog.capture('store-entry', { value: true });
  }

  setContext("SHOP",{
    org,
    product,
    serviceProviders,
    shopData,
    location:writable(location),
    isGlobal
  });

  onMount(() => {
    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );
    if(clientSecret) {
      paymentIntentData = {
        completed:true,
        client_secret:clientSecret
      }
    }
  });

  async function getServiceProviders({type, guid}) {
    loading = true;
    const [error, providers] = await to(Providers.get({type,guid,research:false,is_active:true}));
    loading = false;
    $serviceProviders = providers;
  }

</script>

<style type="text/scss" global>

  .store-wrapper:before {
    @media screen and (min-width:1201px){
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
      background: #ffffff;
      content: " ";
      height: 100%;
      position: fixed;
      right: 0;
      top: 0;
      -webkit-transform-origin: right;
      -ms-transform-origin: right;
      transform-origin: right;
      width: 50%;
    }

  }
  .store-wrapper:before {
    @media screen and (min-width:1201px){
      box-shadow: 15px 0 30px 0 rgba(0,0,0,.18);
    }
  }

  .org-bg {
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: -1;
  }

  .oto-image {
    bottom: 30px;
    img {
      width:100%;
    }

    @media screen and (min-width:1200px){
      margin-top: auto;
      position: fixed;
      width: 245px;
      left: calc(100% / 2 - calc(100% / 3));
    }

    @media screen and (max-width:1200px){
      width: 245px;
    }
  }

  .app-wrapper {
    position: relative;
    width:100%;
    overflow-y:auto;
    display: flex;
    align-items: center;
    height: -webkit-fill-available;
    height: 100dvh;

    @media screen and (min-width:1200px){
      /* stretch so the payment column can scroll; center clips tall Stripe content */
      align-items: stretch;
      justify-content: space-between;
        flex-direction: row;
    }

    @media screen and (max-width:1200px){
      flex-direction: column;
      position:fixed;
      top:0;
      left:0;
      width:100%;
    }
  }

  .org-name {
    .logo {
      max-width:300px;
    }
  }

  .product-info {
    margin-bottom: 0;
    width: calc(100% / 2);
    padding: 0 10%;
    height: auto;

    @media screen and (min-width:1200px){
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    @media screen and (max-width:1200px){
      max-width: calc(100% - 30px);
      width:100%;
      padding:0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      min-height: 190px;

      &.purchase-step {
        min-height: 380px
      }

    }
    @media screen and (max-width: 375px) {
      padding: 0 3%;
    }
  }

  .customer-info {
    margin-bottom: 0;
    width: calc(100% / 2);

    display: flex;
    flex-direction: column;
    align-items: center;
    background:white;

    @media screen and (max-width:1200px){
      padding-bottom: 30px;
      width:100%;
      flex: 1;
    }
    @media screen and (min-width:1200px) and (min-height:1300px){
      background:transparent;
      justify-content: center;
    }
  }


</style>

<Tailwind/>
<div class="store-wrapper absolute top-0 left-0 w-full h-full flex items-center justify-center" class:dark={isDark} class:light={!isDark} style="{cssVarStyles}">
  <div class="org-bg" style="background-color:{org.branding_primary_color}"></div>
  {#if loading}
    <div class="absolute inset-0 bg-gray-900/30 z-2">
      <div class="absolute center-item">
        <Loader />
      </div>
    </div>
  {/if}
  <div class="app-wrapper tfc-onboarding">
    <div class="product-info text-over-primary" class:purchase-step={showPriceDetails} >
      <div class="org-name flex items-center gap-2 mb-3">
        <div class="logo">
          <img class="inline-block rounded-md max-h-20 object-contain" src="{org.branding_logo}" alt="">
        </div>
      </div>
      <!-- <span class="text-over-primary text-2xl lg:text-3xl font-medium">{product.nme}</span> -->
      <ShopProgress bind:currentStep bind:stepComplete />
      <!-- {#if $shopData.serviceProvider}
        <div>
          <i class="fa-solid fa-person mr-3"></i> {serviceProviderTypes[org.type]}: {$shopData.serviceProvider.firstname} {$shopData.serviceProvider.lastname}
        </div>
      {/if}
      {#if $shopData.tier}
        <div>
          Plan: {$shopData.tier}
        </div>
      {/if}
       -->
    </div>

    <div class="customer-info lg:h-full lg:overflow-auto" class:largeScreen >
      {#if currentStep}
      <svelte:component {stepComplete} step={currentStep} this={currentStep.component} />
      {/if}
    </div>
  </div>


  <MediaQuery query="(min-width: 1200px)" let:matches>
  	{#if matches}
      <div class="oto-image shop-product">
        <img src="{familyLogo}" alt="">
      </div>
  	{:else}

    {/if}
  </MediaQuery>

</div>
